import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FacePressuresModelIntervalModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FacePressuresModelIntervalModel._instance == null) FacePressuresModelIntervalModel._instance = new FacePressuresModelIntervalModel(authManager);
        return FacePressuresModelIntervalModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/face-pressures-model-intervals');

        this.entityName = 'face-pressures.FacePressuresModelInterval';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'J S Model Interval';
        this.setLabel = 'J S Model Intervals';

        this.browser = {
            name: 'default-face-pressures-facepressuresmodelinterval-browser',
            moduleName: 'default-face-pressures-facepressuresmodelinterval-browser',
            moduleTitle: 'J S Model Intervals',
            moduleStateSlotName: 'default-face-pressures-facepressuresmodelinterval-browser',
        };

        this.editor = {
            name: 'default-face-pressures-facepressuresmodelinterval-editor',
            moduleName: 'default-face-pressures-facepressuresmodelinterval-editor',
            moduleTitle: 'J S Model Interval',
            moduleStateSlotName: 'default-face-pressures-facepressuresmodelinterval-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'calculationId',
                type: 'FacePressuresCalculation',
                persistent: true,
                label: 'Calculation',
                description: 'reference to particular ps model interval',
                required: true,
            },
            {
                name: 'modelIntervalId',
                type: 'ModelInterval',
                persistent: true,
                label: 'Model Interval',
                description: 'reference to particular ps model interval',
                required: true,
            },
            {
                name: 'modelSectionId',
                type: 'ModelSection',
                persistent: true,
                label: 'Model Section',
                description: 'only for info (check)',
            },
            {
                name: 'isWithinWaterBody',
                type: 'bool',
                persistent: false,
                label: 'Is Within Water Body',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'waterBodyId',
                type: 'WaterBody',
                persistent: false,
                label: 'Water Body',
                description: 'reference to particular water body',
                readOnly: true,
            },
            {
                name: 'waterBodyTypeId',
                type: 'WaterBodyType',
                persistent: false,
                label: 'Water Body Type',
                description: 'reference to particular water body type',
                readOnly: true,
            },
            {
                name: 'waterUnitWeightGamaW',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Water Unit Weight Gama W',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'geoTypeId',
                type: 'GeoType',
                persistent: false,
                readOnly: true,
            },
            {
                name: 'bulkUnitWeightGama',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Bulk Unit Weight Gama',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'dryUnitWeightGamaD',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Dry Unit Weight Gama D',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'saturatedUnitWeightGamaSat',
                type: 'float',
                persistent: false,
                unit: 'kN/m^3',
                label: 'Saturated Unit Weight Gama Sat',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'degreeOfSaturationSr',
                type: 'float',
                persistent: false,
                unit: '1',
                label: 'Degree Of Saturation Sr',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'moistureContentW',
                type: 'float',
                persistent: false,
                unit: '%',
                label: 'Moisture Content W',
                description: 'Moisture (Water) Content Chosen Value',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'soilUnitWeightGamaCalcMethodId',
                type: 'SoilUnitWeightGamaCalculationMethod',
                persistent: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
            },
            {
                name: 'soilUnitWeightGama',
                type: 'float',
                persistent: true,
                unit: 'kN/m^3',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
        ];

    }

}
